// French number-to-words for Tunisian invoices.
// 517,831 DT → "Cinq Cent Dix-sept DT et Huit Cent Trente et Un Millimes"
// The currency unit is "DT" (or "Dinar(s)") and the fractional part (3 digits
// of millimes, since DT is divided in 1000) is spelled out separately.

const UNITS = ['', 'Un', 'Deux', 'Trois', 'Quatre', 'Cinq', 'Six', 'Sept', 'Huit', 'Neuf'];
const TEENS = ['Dix', 'Onze', 'Douze', 'Treize', 'Quatorze', 'Quinze', 'Seize', 'Dix-sept', 'Dix-huit', 'Dix-neuf'];
const TENS = ['', '', 'Vingt', 'Trente', 'Quarante', 'Cinquante', 'Soixante', 'Soixante', 'Quatre-vingt', 'Quatre-vingt'];

function under100(n: number): string {
  if (n < 10) return UNITS[n] ?? '';
  if (n < 20) return TEENS[n - 10] ?? '';
  const t = Math.floor(n / 10);
  const u = n % 10;
  // 70–79: "soixante-dix", "soixante et onze", ..., "soixante-dix-neuf"
  if (t === 7) {
    if (u === 1) return 'Soixante et Onze';
    return `Soixante-${TEENS[u] ?? ''}`;
  }
  // 90–99: "quatre-vingt-dix", "quatre-vingt-onze", ...
  if (t === 9) return `Quatre-vingt-${TEENS[u] ?? ''}`;
  if (u === 0) {
    if (t === 8) return 'Quatre-vingts';
    return TENS[t] ?? '';
  }
  // 21, 31, … 61: "X et Un"
  if (u === 1 && t >= 2 && t <= 6) return `${TENS[t]} et Un`;
  return `${TENS[t]}-${UNITS[u]}`;
}

function under1000(n: number): string {
  if (n < 100) return under100(n);
  const h = Math.floor(n / 100);
  const rest = n % 100;
  const hPart = h === 1 ? 'Cent' : `${UNITS[h]} Cent${rest === 0 ? 's' : ''}`;
  return rest === 0 ? hPart : `${hPart} ${under100(rest)}`;
}

function intToWords(n: number): string {
  if (n === 0) return 'Zéro';
  const parts: string[] = [];
  const b = Math.floor(n / 1_000_000_000);
  const m = Math.floor((n % 1_000_000_000) / 1_000_000);
  const k = Math.floor((n % 1_000_000) / 1_000);
  const r = n % 1_000;
  if (b > 0) parts.push(`${b === 1 ? 'Un' : under1000(b)} Milliard${b > 1 ? 's' : ''}`);
  if (m > 0) parts.push(`${m === 1 ? 'Un' : under1000(m)} Million${m > 1 ? 's' : ''}`);
  if (k > 0) parts.push(k === 1 ? 'Mille' : `${under1000(k)} Mille`);
  if (r > 0) parts.push(under1000(r));
  return parts.join(' ');
}

/** Amount (e.g. 517.831) → "Cinq Cent Dix-sept DT et Huit Cent Trente et Un Millimes". */
export function amountInWordsFr(amount: number): string {
  const rounded = Math.round(amount * 1000) / 1000;
  const dinars = Math.floor(Math.abs(rounded));
  const millimes = Math.round((Math.abs(rounded) - dinars) * 1000);
  const dinarPart = `${intToWords(dinars)} DT`;
  if (millimes === 0) return dinarPart;
  return `${dinarPart} et ${intToWords(millimes)} Millime${millimes > 1 ? 's' : ''}`;
}
